// @flow
import type {PureComputed} from 'rgs-knockout';

import ko from 'rgs-knockout';

export default class BaseComponent {
	isVisible: PureComputed<*>;
	text: PureComputed<*>;
	style: any;
	css: any;

	constructor (params: {}) {
		const {
			visible = true,
			onClick = null,
			style = {},
			text = '',
			css = {},
		} = params || {};


		this.visible = ko.pureComputed(() => ko.unwrap(visible));
		this.text = ko.pureComputed(() => ko.unwrap(text));

		this.onClick = onClick;
		this.style = style;
		this.css = css;
	}
}
